import { IUser, IZoneBase, ITopicBase } from './user.types';

export enum PostSection {
  POSTIME = 'POSTIME',
  LAJME = 'LAJME',
  NARRATIVA = 'NARRATIVA',
  PS = 'PS',
  GALERIA = 'GALERIA',
  KUVEND = 'KUVEND',
  QEVERI = 'QEVERI',
}

export enum SourcePlatform {
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  TIKTOK = 'TIKTOK',
}

export enum PostType {
  TEXT = 'TEXT',
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO',
  DOCUMENT = 'DOCUMENT',
  MIXED = 'MIXED',
}

export enum PostPriority {
  NORMAL = 'NORMAL',
  IMPORTANT = 'IMPORTANT',
  URGENT = 'URGENT',
}

export enum MediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  DOCUMENT = 'DOCUMENT',
}

export interface IMedia {
  id: string;
  type: MediaType;
  url: string;
  filename: string;
  mimeType: string;
  size: number;
  thumbnailUrl: string | null;
  duration: number | null;
  order: number;
}

export interface ILinkPreview {
  url: string;
  platform: SourcePlatform | null;
  title: string | null;
  image: string | null;
  profileName: string | null;
  publishedAt: string | null;
  viewCount: number | null;
}

export interface ITagBase {
  id: string;
  name: string;
  slug: string;
}

export interface ICategoryBase {
  id: string;
  name: string;
  slug: string;
}

export interface IPost {
  id: string;
  author: Pick<IUser, 'id' | 'firstName' | 'lastName' | 'role' | 'avatarUrl' | 'position'>;
  section: PostSection;
  type: PostType;
  priority: PostPriority;
  title: string | null;
  content: string | null;
  sourceUrl: string | null;
  sourcePlatform: SourcePlatform | null;
  sourceTitle: string | null;
  sourceImage: string | null;
  sourceProfileName: string | null;
  sourcePublishedAt: string | null;
  sourceViewCount: number | null;
  showOnHome: boolean;
  media: IMedia[];
  zones: IZoneBase[];
  topics: ITopicBase[];
  tags: ITagBase[];
  categories: ICategoryBase[];
  isPublished: boolean;
  publishedAt: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface IPostCreate {
  section: PostSection;
  type: PostType;
  priority?: PostPriority;
  title?: string;
  content?: string;
  sourceUrl?: string;
  showOnHome?: boolean;
  sendNotification?: boolean;
  zoneIds?: string[];
  topicIds?: string[];
  mediaIds?: string[];
  tagIds?: string[];
  categoryIds?: string[];
  newTags?: string[];
  newCategories?: string[];
}

export interface IPostUpdate {
  title?: string;
  content?: string;
  priority?: PostPriority;
  showOnHome?: boolean;
  zoneIds?: string[];
  topicIds?: string[];
  tagIds?: string[];
  categoryIds?: string[];
}

export interface ISearchSuggestionPost {
  id: string;
  title: string | null;
  section: PostSection;
  publishedAt: string;
  author: { firstName: string; lastName: string };
  sourcePlatform: SourcePlatform | null;
  sourceProfileName: string | null;
  sourceTitle: string | null;
}

export interface ISearchSuggestions {
  posts: ISearchSuggestionPost[];
  tags: ITagBase[];
  categories: ICategoryBase[];
  zones: IZoneBase[];
  topics: ITopicBase[];
  users: Array<{
    id: string;
    firstName: string;
    lastName: string;
    role: string;
    avatarUrl: string | null;
  }>;
}

export interface IPostFilters {
  section?: PostSection;
  zone?: string;
  topic?: string;
  tag?: string;
  category?: string;
  priority?: PostPriority;
  type?: PostType;
  authorId?: string;
  search?: string;
  page?: number;
  limit?: number;
  sort?: 'latest' | 'oldest';
  startDate?: string;
  endDate?: string;
}
